/**
 * @file
 * @fileOverview This file contains the AppDataManager class for the app.
 * @version 1.0.0
 * @author Parker Eli Bidigare
 * @date 2024-05-26
 */

class AppDataManager {
  constructor(jsonUrl) {
    this.jsonUrl = jsonUrl;
    this.appData = null;
  }

  async fetchAppData() {
    try {
      const response = await fetch(this.jsonUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      this.appData = await response.json();
    } catch (error) {
      console.error('Error fetching app data:', error);
    }
  }

  getAllAppData() {
    if (!this.appData) {
      console.warn('App data not fetched yet. Call fetchAppData() first.');
      return null;
    }
    return this.appData;
  }
}

export default AppDataManager;
